@if (chipList() && chipList().length) {
    <div class="chip-group row">
        @for (chip of chipList(); track chip.value) {
            <div class="row ps-2">
                <button class="chip-container" (click)="onChipSelection(chip)">
                    @if (chip.iconUrl) {
                        <img class="chip-icon" [src]="chip.iconUrl" placement="left">
                    }
                    <span class="chip-content">{{chip.value }}</span>
                </button>
            </div>
        }
    </div>
}